export default "__VITE_ASSET__7b853544__"